import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuService } from '@app/_services/menu.service';
import { IdiomasService } from '@app/_services/idiomas.service';
import { Idioma } from '@app/_models/idioma';
import {
  AlertService,
} from '@app/_services';
import { Recinto, RecintoTrad, Sala, SalaTrad } from '@app/_models/recinto';
import  {BloqueInput, Equipo, EquipoTrad, Jugador, JugadorTrad} from '@app/_models/equipo'
import { EquiposService } from '@app/_services/equipos.service';

@Component({
  selector: 'grid-jugadores',
  templateUrl: './jugadores.component.html'
})
export class JugadoresComponent implements OnInit {

  idOrg:string;
  //Listas
  listaIdiomas: Idioma[] = [];
  listaIdiomasTotales: Idioma[] = [];
  listaTraducciones: Idioma[] = [];
  //Traducciones
  listaTraduccionesEnviar: JugadorTrad[] = [];
  //Data
  myJugador:Jugador=new Jugador();
  selectedIdioma: Idioma;
  filePath: string;
  filePathFondo: string;
  private translate: TranslateService;
  lang;
  myPosicion:string='';
  myLateralidad:string='';
  myObservaciones:string='';
  myNacionalidad:string='';
  listaCustomPlantilla:BloqueInput[];

  constructor(
    private equiposService: EquiposService,
    private idiomaService: IdiomasService,
    private menuService: MenuService,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    translate: TranslateService,
    private translateService: TranslateService
  ) {
    this.translate = translate;
    this.menuService.titulo = this.translate.instant('equipos.createjugador');
  }

  ngOnInit(): void {
    this.myJugador.idEquipo =this.route.snapshot.params['idequipo'];
    this.myJugador.idTemporada =this.route.snapshot.params['idtemporada']; 
    this.idOrg = this.route.snapshot.params['idorg'];
    this.lang = this.translateService.getDefaultLang();

    //Load Langs
    this.idiomaService.GetAll().subscribe((result) => {
      this.listaIdiomasTotales = result.data;
      console.log('Cargados idiomas = ' + this.listaIdiomasTotales.length);
      this.listaIdiomasTotales.forEach((x) => {
        const trad = new JugadorTrad();
        trad.filled = false;
        trad.idIdioma = x.codigo;
        trad.nombreIdioma = x.nombre;
        this.listaTraduccionesEnviar.push(trad);
      });
    });

    this.idiomaService.getIdiomasFromEnte(this.idOrg).subscribe((result) => {
      this.listaIdiomas = result.data;
      if (this.listaIdiomas.length > 0)
        this.selectedIdioma = this.listaIdiomas[0];
    });

    this.equiposService.getPlantillaDatosCustom(this.idOrg).subscribe((result)=>{
      this.listaCustomPlantilla = result.data;
    });

  }

   crearJugador() {
    console.log('Creando Jugador');
    //Validación de los datos
    if (this.listaTraducciones.length <= 0) {
      this.alertService.info(
        this.translateService.instant('publicaciones.errortrads')
      );
      return;
    }
    if (this.filePath == null) {
      this.alertService.info(
        this.translateService.instant('publicaciones.validaciondatos')
      );
      return;
    }

    //AutoCompletado de Idiomas
    //seleccionado
    let seleccionado: JugadorTrad = new JugadorTrad();
    let encontrado: boolean = false;
    this.listaTraduccionesEnviar.forEach((trad) => {
      if (trad.filled && !encontrado) {
        seleccionado = trad;
        encontrado = true;
        return;
      }
    });
    //Fill UnFilled
    this.listaTraduccionesEnviar.forEach((trad) => {
      if (!trad.filled) {
        trad.posicion = seleccionado.posicion;
        trad.lateralidad = seleccionado.lateralidad;
        trad.observaciones = seleccionado.observaciones;
        trad.nacionalidad = seleccionado.nacionalidad;
      }
    });

    this.myJugador.listaTraducciones = this.listaTraduccionesEnviar;
    this.myJugador.urlFoto = this.filePath.split(',')[1]; //Borramos cabecera data: base64
    this.myJugador.urlFondo = this.filePathFondo.split(',')[1]; //Borramos cabecera data: base64
    //Datos Plantilla Jugador
    this.myJugador.listaDatosPlantilla = this.listaCustomPlantilla;
    this.equiposService.crearJugador(this.myJugador).subscribe((result) => {
      if (!result.error) {
        this.alertService.success(
          this.translateService.instant('registros.success')
        );
        this.router.navigate(['equipos-editar',{idEquipo:this.myJugador.idEquipo, idorg:this.idOrg }]);
      } else {
        this.alertService.error(
          this.translateService.instant('registros.error')
        );
        return;
      }
    });
  }
   btnCancelar(){
    this.router.navigate(['equipos-editar',{idEquipo:this.myJugador.idEquipo, idorg:this.idOrg }]);
  }


  btnAddTraduccion() {
    console.log('Comprobando datos');
    if (
      this.selectedIdioma == null ||
      this.myPosicion.length <= 0 ||
      this.myLateralidad.length <= 0 || this.myObservaciones.length<=0 || this.myNacionalidad.length<=0
    ) {
      if (this.listaTraducciones.length <= 0) {
        this.alertService.info(
          this.translateService.instant('publicaciones.validacion')
        );
        return;
      }
    }
    console.log('Datos validados --->');
    if (!this.listaTraducciones.includes(this.selectedIdioma)) {
      this.listaTraducciones.push(this.selectedIdioma);

      this.listaTraduccionesEnviar.map((x) => {
        if (x.idIdioma == this.selectedIdioma.codigo) {
          x.filled = true;
          x.posicion = this.myPosicion;
          x.lateralidad = this.myLateralidad;
          x.observaciones = this.myObservaciones;
          x.nacionalidad = this.myNacionalidad;
        }
      });
    } else {
      console.log('Idioma ya añadido');
    }

    console.log(this.listaTraduccionesEnviar);
  }

  btnDeleteTraduccion(idioma: Idioma) {
    console.log(idioma);
    this.listaTraducciones = this.listaTraducciones.filter(
      (x) => x.codigo != idioma.codigo
    );

    this.listaTraduccionesEnviar.map((x) =>
      x.idIdioma == idioma.codigo ? (x.filled = false) : console.log()
    );

    console.log(this.listaTraduccionesEnviar);
  }

  imagePreview(e) {
    const file = (e.target as HTMLInputElement).files[0];
    const reader = new FileReader();
    reader.onload = () => {
      this.filePath = reader.result as string;
    };
    reader.readAsDataURL(file);
  }
  imagePreviewFondo(e) {
    const file = (e.target as HTMLInputElement).files[0];
    const reader = new FileReader();
    reader.onload = () => {
      this.filePathFondo = reader.result as string;
    };
    reader.readAsDataURL(file);
  }


}
